import styled from 'styled-components';
import welcomeSvg from '../../assets/images/welcome.svg';

const TOUR_DASHBOARD_CONTENT = [
  {
    content: <img src={welcomeSvg} alt="step" style={{ marginRight: '8px' }} />,
    placement: 'center',
    target: 'body'
  },
  {
    title: 'Transaction Report',
    content: 'View custom records of all transactions using filters to refine view.',
    placement: 'bottom',
    target: '.dashboard-transaction-page'
  },
  {
    title: 'Commission Report',
    content: 'View commissions data by payment mode for a detailed breakdown of earnings.',
    placement: 'bottom',
    target: '.dashboard-commission-page'
  },
  {
    content: (
      <div>
        <h2>End</h2>
      </div>
    ),
    placement: 'center',
    target: 'body'
  }
];

const QUICKSIGHT_PARTNER_ID = [76676, 4486, 139953];

const COMMISSION_PAYMENT_MODE_COLUMNS_EXPORT = {
  mode: 'Payment Mode',
  total: 'Total Commission'
};

const ReportTabBarWrapper = styled.div`
  && {
    .ant-tabs-tab {
      margin-bottom: 14px !important;
      background-color: white !important;
      border: 1px solid #d9d9d9 !important;
      color: black !important;
      border-radius: 0px !important; /* Reset all first */
      transition: none !important;
    }

    .ant-tabs-nav-list > .ant-tabs-tab:nth-of-type(1) {
      border-top-left-radius: 8px !important;
      border-bottom-left-radius: 8px !important;
    }

    .ant-tabs-nav-list > .ant-tabs-tab:nth-of-type(2) {
      border-top-right-radius: 8px !important;
      border-bottom-right-radius: 8px !important;
    }

    .ant-tabs-nav-list > .ant-tabs-tab:nth-of-type(3) {
      border-top-right-radius: 8px !important;
      border-bottom-right-radius: 8px !important;
    }

    .ant-tabs-nav::before {
      content: none !important;
      position: none;
    }

    .ant-tabs-tab {
      color: black !important;
      padding: 6px 30px !important;
    }

    .ant-tabs-nav .ant-tabs-tab-active {
      background: var(--color-primary) !important;
      border: 1px solid var(--color-primary) !important;

      .ant-tabs-tab-btn {
        color: rgb(255, 255, 255) !important;
      }
    }

    .ant-tabs-nav {
      margin: 0px;
    }
  }
`;
const formatPaymentMode = (value) => {
  const specialCases = {
    na: 'Others',
    cash_card: 'Wallet',
    neft: 'NEFT',
    imps: 'IMPS',
    upi: 'UPI',
    emi: 'EMI',
    rtgs: 'RTGS',
    enach: 'ENACH'
  };

  if (specialCases[value]) return specialCases[value];

  return value.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
};

const renderTabBarReport = (props, DefaultTabBar) => {
  return (
    <ReportTabBarWrapper>
      <DefaultTabBar {...props} />
    </ReportTabBarWrapper>
  );
};

export {
  TOUR_DASHBOARD_CONTENT,
  QUICKSIGHT_PARTNER_ID,
  renderTabBarReport,
  COMMISSION_PAYMENT_MODE_COLUMNS_EXPORT,
  formatPaymentMode
};
